import { MessageItems } from "@/types/admin_types";
type Props = {
  el: MessageItems
}

export default function MessageDetails({ el }: Props) {
  return (
    <div className="flex items-center justify-center">
      <p>{el?.message}</p>
    </div>
  )
}
